export const contactAndLegal = {
  verificationInfo: "Πληροφορίες Επαλήθευσης",
  contactEmail: "Email Επικοινωνίας",
  contactInfo: "Πληροφορίες Επικοινωνίας",
};
